/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import axios from '../../../services/http.service';

function HeadDepartmentsPageV3({ title }) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchDepartmentsAndRedirect() {
      try {
        const departments = await axios({
          method: 'GET',
          url: 'head/departments/',
        });

        if (departments && departments.length > 0) {
          // Redirect to first department's dashboard
          history.replace(`/head/departments/${departments[0].name}/dashboard`);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Failed to fetch departments:', error);
        setIsLoading(false);
      }
    }

    fetchDepartmentsAndRedirect();
  }, [history]);

  // Show loading state while fetching departments
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Loading departments...</p>
        </div>
      </div>
    );
  }

  // Show message if no departments available
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-foreground mb-2">No Departments Available</h1>
        <p className="text-muted-foreground">
          You don&apos;t have access to any departments. Please contact your administrator.
        </p>
      </div>
    </div>
  );
}

HeadDepartmentsPageV3.propTypes = {
  title: PropTypes.string,
};

HeadDepartmentsPageV3.defaultProps = {
  title: 'Head Panel',
};

export default HeadDepartmentsPageV3;
